import Service from '@/helpers/service'

export default {

    show() {
        return Service().get('setting-potongan/show');
    },
    update(params) {
        return Service().post('setting-potongan/update', params);
    },
}
